import Component from '../../abstracts/Component';

export default class AccordionMixinComponent extends Component {
  get CSS() {
    return {
      expanded: '--expanded'
    };
  }

  constructor(elem) {
    super(elem);
    this.collapse = this.collapse.bind(this);
    this.expand = this.expand.bind(this);
    this.toggle = this.toggle.bind(this);
    this.isExpanded = this.isExpanded.bind(this);
  }

  render() {
  }

  // API
  collapse() {
    this.$component.classList.remove(this.CSS.expanded);
    this.emit(this.$customEvents.ACCORDION.collapse);
  }

  expand() {
    this.$component.classList.add(this.CSS.expanded);
    this.emit(this.$customEvents.ACCORDION.expand);
  }

  isExpanded() {
    return this.$component.classList.contains(this.CSS.expanded);
  }

  toggle() {
    if (this.isExpanded()) {
      this.collapse();
    } else {
      this.expand();
    }
  }
}
